import type { NodeDetail, NodeRef } from "../engine/types.ts";

export interface BreadcrumbCallbacks {
  onNavigate: (id: string) => void;
  onBack: () => void;
  onForward: () => void;
  onHome: () => void;
}

/** Barra superior: voltar/avançar/home + trilha clicável (Sol → … → nó). */
export class Breadcrumbs {
  private trailEl!: HTMLElement;
  private backBtn!: HTMLButtonElement;
  private fwdBtn!: HTMLButtonElement;

  constructor(private cb: BreadcrumbCallbacks) {}

  mount(root: HTMLElement) {
    root.insertAdjacentHTML(
      "beforeend",
      `<nav id="breadcrumbs" class="panel">
        <button class="nav-btn" id="bc-back" title="Voltar (Alt+←)" disabled>‹</button>
        <button class="nav-btn" id="bc-fwd" title="Avançar (Alt+→)" disabled>›</button>
        <button class="nav-btn" id="bc-home" title="Visão geral (Esc)">⌂</button>
        <div id="bc-trail"><span class="bc-crumb bc-sun" data-nav="__council__">Strategic Council</span></div>
      </nav>`,
    );
    this.trailEl = root.querySelector("#bc-trail") as HTMLElement;
    this.backBtn = root.querySelector("#bc-back") as HTMLButtonElement;
    this.fwdBtn = root.querySelector("#bc-fwd") as HTMLButtonElement;
    this.backBtn.addEventListener("click", () => this.cb.onBack());
    this.fwdBtn.addEventListener("click", () => this.cb.onForward());
    (root.querySelector("#bc-home") as HTMLElement).addEventListener("click", () => this.cb.onHome());
    this.trailEl.addEventListener("click", (e) => {
      const t = (e.target as HTMLElement).closest("[data-nav]") as HTMLElement | null;
      if (t?.dataset.nav) this.cb.onNavigate(t.dataset.nav);
    });
  }

  setHistory(canBack: boolean, canForward: boolean) {
    this.backBtn.disabled = !canBack;
    this.fwdBtn.disabled = !canForward;
  }

  update(detail: NodeDetail | null) {
    const trail: NodeRef[] = detail?.trail ?? [];
    if (!trail.length) {
      this.trailEl.innerHTML = `<span class="bc-crumb bc-sun" data-nav="__council__">Strategic Council</span>`;
      return;
    }
    // colapsa o meio se muito longo: primeiro · … · 2 últimos
    let items = trail;
    let ellipsis = false;
    if (trail.length > 4) { items = [trail[0], ...trail.slice(-3)]; ellipsis = true; }
    const html = items
      .map((r, i) => {
        const sep = i === 0 ? "" : ellipsis && i === 1 ? `<span class="bc-sep">…</span>` : `<span class="bc-sep">›</span>`;
        const cur = r.id === detail!.id ? " bc-current" : "";
        return `${sep}<span class="bc-crumb${cur}" data-nav="${esc(r.id)}">${esc(r.label)}</span>`;
      })
      .join("");
    this.trailEl.innerHTML = html;
  }
}

function esc(s: string): string {
  return s.replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c] as string));
}
